import { Component, OnInit } from '@angular/core';
import { cloneDeep, filter } from 'lodash';
import { Feature } from 'ol';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { ArincFOMEnum } from 'src/app/models/ArincFOMEnum';
import { FilterModel } from 'src/app/models/filter';
import { FreqConversionUtil } from 'src/app/models/FreqConversionUtil';
import { icaoccModel } from 'src/app/models/icaoccModel';
import { ProceduresFilterService } from 'src/app/services/procedures-filter.service';
import { PointsService } from 'src/app/services/points.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { ProceduresService } from 'src/app/services/procedures.service';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { ProcedureModel } from 'src/app/models/procedure';

import {  CoordinatePointsService} from 'src/app/services/coordinate-points.service';
import {  CoordinatePointsFilterService } from 'src/app/services/coordinate-points-filter.service';
import { TabsService } from 'src/app/services/tabsService';
import { SaamTrafficService } from 'src/app/services/saamtrafficservice';
import { FiltersOfType, UserSettingsService } from 'src/app/services/userSettings.service';
import { FeatureType } from 'src/app/models/EnumTypes';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-coordinate-points-filter',
  templateUrl: './coordinate-points-filter.component.html',
  styleUrls: ['./coordinate-points-filter.component.scss'],
  standalone: false
})
export class CoordinatePointsFilterComponent implements OnInit {

  selectedField : string;
  selectedValue : string;
  values : string[] = [];
  filters : FilterModel[] = [];
  filterBy: string;

  publishedString: string;
  showPublishedSlider: boolean = false;
  isPublishedSliderChecked: boolean = false;

  dropdown_values_enabled: boolean = false;
  isReferenceAirportFilter: boolean = false;
  airportSelectOnMapActive : boolean = false;
  keyword = 'composedName';

  constructor(
    public coodinatePointsFilterController: CoordinatePointsFilterService,
    public coordinatePointsService: CoordinatePointsService,
    public menuController : MenuManagementService,
    private toolsService : ToolsControlService,
    public pointsService : PointsService,
    public  selectCoordinatePointService : SelectCoordinatePointsControlService,
    public tabsService: TabsService,
    public userSettingsService: UserSettingsService,
    private uiBlock: UiBlockService,
    private mapService: MapService,
  ) { }

  ngOnInit(): void {
    this.typeChanged('type');
    this.publishedString = 'User Defined';

    // Subscribe to window opened event to refresh display message
    this.coodinatePointsFilterController.windowOpened$.subscribe(() => {
      this.forceFilterRefresh();
    });
  }

  async forceFilterRefresh(): Promise<void> {
    this.uiBlock.startBlock("Getting Coordinate Points...");
    // Get all coordinate points to calculate counts
    const allCoordinatePoints = await this.pointsService.getCoordinatePoints().toPromise();
    const totalCount = allCoordinatePoints.length;

    // If there are active filters, apply them to get filtered count
    let displayedCount = totalCount;
    if (this.coodinatePointsFilterController.filters.some(f => f.active)) {
      const filteredPoints = this.pointsService.applyFiltersToCoordinatePointsList(allCoordinatePoints);
      displayedCount = filteredPoints.length;
    }

    // Update the display message
    this.pointsService.informationMessageCoordinatePoints = "Displaying " + displayedCount + " of " + totalCount + ".";
    this.uiBlock.stopBlock();
  }

  public typeChanged( $event ) {
    this.values = [];
    this.filterBy = $event;
    switch($event){
      case 'type':
        this.values.push("WAYPOINT");
        this.values.push("ARP_CIVIL");
        this.values.push("ARP Militar");
        this.values.push("RWY THR");
        this.values.push("Airspace Boundary Vertex");
        this.values.push("ARP Mixed");
        this.values.push("Fix Point");
        this.dropdown_values_enabled = true;
        this.isReferenceAirportFilter = false;
        this.showPublishedSlider = false;
        break;
      case 'published':
        this.isReferenceAirportFilter = false;
        this.dropdown_values_enabled = false;
        this.showPublishedSlider = true;
        break;
      default:
        this.isReferenceAirportFilter = false;
        this.dropdown_values_enabled = false;
        this.showPublishedSlider = false;
    }
  }

  updatePublishedLabel(): string {
    return this.isPublishedSliderChecked ? 'Published' :'User Defined';
  }

  addFilter():void {
    let filter_item : FilterModel = new FilterModel();

    if (this.filterBy === 'type') {
      let selected = document.getElementById("filter_typeCoordinatePoints") as HTMLSelectElement;
      if (selected != null){
        filter_item.field = selected.options[selected.selectedIndex].text;
        filter_item.value = (<HTMLInputElement>document.getElementById("valuesCoordinatePoints")).value;
      }
    }
    else {
      filter_item.field = 'Published';
      filter_item.value = this.isPublishedSliderChecked ? 'published' : 'userdefined';
    }


    this.coodinatePointsFilterController.filters.push(filter_item);
  }

  async applyFilter() {
    this.uiBlock.startBlock("Applying Filter...");
    if (this.coodinatePointsFilterController.filters.length > 0) {
      for (const filter of this.coodinatePointsFilterController.filters) {
        filter.active = true;
      }

      this.pointsService.deleteCoordinatePointsFromMap();
      await this.pointsService.fetchAndAddCoordinatePoints();

      this.userSettingsService.updateFilters(FiltersOfType.CoordinatePoints, this.coodinatePointsFilterController.filters);
    }
    this.uiBlock.stopBlock();
  }

  selectFilter(filter : FilterModel) {
    this.coodinatePointsFilterController.filters.forEach( elm => {
      if((filter.field == elm.field) && (filter.value == elm.value)){
        elm.isSelected = true;
      }else {
        elm.isSelected = false;
      }
    });
  }

  async deleteSelectedFilterFromList(){
    // Verificar se há algum filtro selecionado antes de fazer qualquer operação
    const hasSelectedFilter = this.coodinatePointsFilterController.filters.some(filter => filter.isSelected);

    if (!hasSelectedFilter) {
      return; // Não fazer nada se não há filtros selecionados
    }

    this.uiBlock.startBlock("Removing Selected Filters...");

    this.coodinatePointsFilterController.filters = this.coodinatePointsFilterController.filters.filter(item => !item.isSelected);

    this.userSettingsService.updateFilters(FiltersOfType.CoordinatePoints, this.coodinatePointsFilterController.filters);

    this.pointsService.deleteCoordinatePointsFromMap();

    //if there are still filters, fetch and add coordinate points based on remaining filters
    if (this.coodinatePointsFilterController.filters.length > 0) {
      await this.pointsService.fetchAndAddCoordinatePoints();
    } else {
      //if no more filters, just fetch based on extent
      const extent = this.mapService.getCurrentExtent();
      await this.pointsService.fetchAndAddPartialCoordinatePoints(extent);
      this.pointsService.informationMessageCoordinatePoints = "Displaying " + this.pointsService.totalCoordinatePointsInProject + " of " + this.pointsService.totalCoordinatePointsInProject + ".";
    }
    this.uiBlock.stopBlock();

  }
  async resetFilters(): Promise<void> {
    if (this.coodinatePointsFilterController.filters.length === 0) {
      return;
    }
    this.uiBlock.startBlock("Resetting Filters...");

    this.coodinatePointsFilterController.filters = [];
    this.userSettingsService.updateFilters(FiltersOfType.CoordinatePoints, this.coodinatePointsFilterController.filters);
    this.pointsService.deleteCoordinatePointsFromMap();
    const extent = this.mapService.getCurrentExtent();
    await this.pointsService.fetchAndAddPartialCoordinatePoints(extent);
    this.pointsService.informationMessageCoordinatePoints = "Displaying " + this.pointsService.totalCoordinatePointsInProject + " of " + this.pointsService.totalCoordinatePointsInProject + ".";
    this.uiBlock.stopBlock();
  }

  cancelWindow():void{
    this.coodinatePointsFilterController.active = !this.coodinatePointsFilterController.active;
    this.toolsService.navigationOnTop = false;
  }
}
